import { TenantInfo } from "../models/tenant.model";

export interface TenantSwitchingState {
  availableTenants: TenantInfo[];
  selectedTenantId: string | null;
  loading: boolean;
  error: string | null;
  isSwitching: boolean;
}

export const initialTenantSwitchingState: TenantSwitchingState = {
  availableTenants: [],
  selectedTenantId: null,
  loading: false,
  error: null,
  isSwitching: false
};
